'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var index_es = require('./index.es-1f72f6f2.js');

var Container = styled__default.div(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject([""], [""])));
var Title = styled__default.div(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  font: 700 36px/36px ", ";\n  padding-top: ", ";\n  color: ", ";\n"], ["\n  font: 700 36px/36px ", ";\n  padding-top: ", ";\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var hasIcon = _a.hasIcon;
    return (hasIcon ? '26px' : '0px');
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var IconTextContainer = styled__default.div(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  display: 'flex';\n  align-items: center;\n  height: auto;\n  cursor: pointer;\n  font: 500 14px/16px ", ";\n  color: ", ";\n  &:hover,\n  &:focus {\n    font: 800 14px/16px ", ";\n    outline: none;\n    border-color: none;\n  }\n"], ["\n  display: 'flex';\n  align-items: center;\n  height: auto;\n  cursor: pointer;\n  font: 500 14px/16px ", ";\n  color: ", ";\n  &:hover,\n  &:focus {\n    font: 800 14px/16px ", ";\n    outline: none;\n    border-color: none;\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var Icon = styled__default(index_es.FontAwesomeIcon)(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  height: auto;\n  margin-right: 6px;\n  color: ", ";\n"], ["\n  height: auto;\n  margin-right: 6px;\n  color: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

exports.Container = Container;
exports.Icon = Icon;
exports.IconTextContainer = IconTextContainer;
exports.Title = Title;
